const features = [
  {
    icon: 'ri-flashlight-line',
    title: '全网最快',
    desc: '7×24小时实时追踪微博、抖音、小红书等100+主流平台，热点事件发生后15分钟内上线爆料，确保你永远比朋友先知道最新吃瓜动态。',
  },
  {
    icon: 'ri-stack-line',
    title: '内容最全',
    desc: '从娱乐圈八卦到网红翻车，从社会热点到影视争议，51爆料吃瓜网涵盖八大内容分类，日均更新200+条，一个网站看遍全网的瓜。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '来源可靠',
    desc: '所有爆料内容标注来源出处，未经证实的传闻明确标注标签，倡导理性吃瓜，不传谣不信谣，为你筛选最有价值的爆料信息。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            为什么百万吃瓜群众选择51爆料
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="group text-center p-6 md:p-8 bg-background-100 rounded-2xl border border-background-200/60 hover:border-accent-300/50 transition-all cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 rounded-2xl bg-accent-100 flex items-center justify-center group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-2xl md:text-3xl text-accent-600`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-950 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}